import {RequestStatus} from './RequestStatus';

/**
 * @export
 * @type ApprovalRequestSearchCriteria
 */
export type ApprovalRequestSearchCriteria = {
    /**
     * id of the vendor associated with the request
     */
    vendorId?: string;
    /**
     * current page number
     */
    page: number;
    /**
     * number of items per page
     */
    pageSize: number;
    requestStatuses?: Array<RequestStatus>;
    /**
     * email associated with the request
     */
    email?: string;
    /**
     * first name associated with the request
     */
    firstName?: string;
    /**
     * sort order of the results
     */
    sortOrder?: ApprovalRequestSearchCriteriaSortOrder;
    /**
     * last name associated with the request
     */
    lastName?: string;
}

export enum ApprovalRequestSearchCriteriaSortOrder {
    ASC = 'ASC',
    DESC = 'DESC'
}